module.exports = __webpack_public_path__ + "img/newsImg3-19.d97a5b61.png";